/* ==========================================================================
   wave-checklist.js — add-to-cart for the wave-guide checklist table.

   Forked from pdp-wave-carousel.js (cart half only — no carousel here). The
   fork is deliberate rather than a shared module: pdp-wave-carousel.js is
   loaded only on product templates, and this section renders on articles.

   WHY WE POST THE CART OURSELVES instead of using the theme's
   is="product-form": Downpay's page script claims product forms and resets
   their selling_plan, which silently dropped the deposit plan off wave adds —
   the customer got charged in full instead of $0-due-today. The variant and
   plan ids ride in data-* attributes, which Downpay does not touch, and we
   append selling_plan explicitly below. Do not refactor this into a form.

   Listener is on the CAPTURE phase for the same reason — we need to win
   before any Downpay-attached bubble-phase handler sees the click.

   Cart UI is driven through the theme's own cartUpdate pubsub, falling back
   to the cart:refresh event, so the drawer behaves exactly as it does
   everywhere else. (Jordan 2026-07-30)
   ========================================================================== */
(function () {
  if (window.__jaysWaveChecklistInit) return;
  window.__jaysWaveChecklistInit = true;

  function routes() { return (window.theme && theme.routes) || {}; }

  function collectSections() {
    // Lets the cart drawer register its section so /cart/add returns its HTML.
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } })
    );
    return sections;
  }

  function setBusy(btn) {
    var labelEl = btn.querySelector('[data-wc-add-label]');
    btn._wcLabelEl = labelEl;
    btn._wcOriginal = labelEl ? labelEl.textContent : '';
    btn.setAttribute('aria-disabled', 'true');
    btn.setAttribute('aria-busy', 'true');
    if (labelEl) labelEl.textContent = 'Adding…';
  }

  function clearBusy(btn) {
    btn.removeAttribute('aria-disabled');
    btn.removeAttribute('aria-busy');
    if (btn._wcLabelEl) btn._wcLabelEl.textContent = btn._wcOriginal;
  }

  // Re-render the cart drawer + count off a fresh cart, then open it.
  function afterAdd(state, trigger) {
    var cartUrl = routes().cart_url || '/cart';
    return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cart.sections = state.sections;
        var published = false;
        try {
          if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
              source: 'wave-checklist',
              cart: cart
            });
            published = true;
          }
        } catch (e) { /* fall through to cart:refresh */ }

        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') {
          if (!published) document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
          drawer.show(trigger);
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        }
      });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) throw new Error(state.description || 'Add to cart failed');
        return state;
      });
  }

  function addItem(btn) {
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    var plan = btn.getAttribute('data-selling-plan');

    setBusy(btn);

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    // The whole reason this file exists — the plan must survive to /cart/add.
    if (plan) body.append('selling_plan', plan);

    var sections = collectSections();
    if (sections.length) {
      body.append('sections', sections.join(','));
      body.append('sections_url', window.location.pathname);
    }

    post(routes().cart_add_url || '/cart/add', body)
      .then(function (state) { return afterAdd(state, btn); })
      .catch(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      })
      .then(function () { clearBusy(btn); });
  }

  // Capture phase so we win before any Downpay-attached bubble handler.
  document.addEventListener(
    'click',
    function (e) {
      if (!e.target.closest) return;
      var btn = e.target.closest('[data-wc-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addItem(btn);
    },
    true
  );
})();
